import SnippetType from '../constants/SnippetType';
import BaseModel from './BaseModel';
import { LanguageCode } from './common';

export interface SnippetId {__snippetId: number}

export default class Snippet extends BaseModel<SnippetId> {
  type: SnippetType | null = null;
  content = '';
  title = '';
  language: LanguageCode | null = null;
  isDefaultLocked = false;
}
